import { render } from "./FridgeEconaviContentItem.vue?vue&type=template&id=0187574f&scoped=true&ts=true"
import script from "./FridgeEconaviContentItem.vue?vue&type=script&lang=ts"
export * from "./FridgeEconaviContentItem.vue?vue&type=script&lang=ts"

import "./FridgeEconaviContentItem.vue?vue&type=style&index=0&id=0187574f&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0187574f"]])

export default __exports__